"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Project = void 0;
const Target_1 = require("./Target");
class Project {
    constructor(data) {
        this.id = null;
        this.name = null;
        this.actionCode = null;
        this.clientName = null;
        this.status = 'draft';
        this._targets = [];
        if (data) {
            this.hydrate(data);
        }
    }
    hydrate(data) {
        this.id = data.id || null;
        this.name = data.name || null;
        this.actionCode = data.actionCode || null;
        this.status = data.status || null;
        this.clientName = data.clientName || null;
        this.keyAccount = data.keyAccount || null;
        if (typeof data._targets !== "undefined" && data._targets !== null) {
            this._targets = data._targets.map(target => new Target_1.Target(target));
        }
        if (typeof data._briefing !== "undefined" && data._briefing !== null) {
            this._briefing = data._briefing;
        }
        if (typeof data._comments !== "undefined" && data._comments !== null) {
            this._comments = data._comments;
        }
    }
    getScalarProperties() {
        return Object.keys(this).filter((key) => ['keyAccount', '_targets', '_briefing', '_comments'].indexOf(key) === -1);
    }
}
exports.Project = Project;
//# sourceMappingURL=Project.js.map